import { FunctionComponent } from "react";
import rutasAdminUsuarios from "./admin-usuarios";
import rutasComplArchivos from "./compl-archivos";
import rutaOtros from "./otros";

const allRoutes: Array<{ path: string, elemento: FunctionComponent }>= [
    ...rutasAdminUsuarios,
    ...rutasComplArchivos,
    ...rutaOtros
]



export default allRoutes;